module.exports = __webpack_public_path__ + "static/media/bg.a47fb5e0.jpg";